import Vue from "vue";
import Vuex from "vuex"

Vue.use(Vuex);//挂载

const store = new Vuex.Store({
    state:{
        //登录存储
        LoginStorage:'',
        vipshow:false
    },
    mutations:{
        //修改登录的存储信息
        LoginModification(state,w){
            state.LoginStorage = w;
        },
        //设置充值弹窗显示状态
        setVipshow(state, value){
            state.vipshow = value;
        }
    }
});

export default store